import { render, staticRenderFns } from "./InputTagObject.vue?vue&type=template&id=8d2eb95e&scoped=true&"
import script from "./InputTagObject.vue?vue&type=script&lang=js&"
export * from "./InputTagObject.vue?vue&type=script&lang=js&"
import style0 from "./InputTagObject.vue?vue&type=style&index=0&id=8d2eb95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2eb95e",
  null
  
)

export default component.exports